/** @format */

import React, { useState, useEffect, useRef } from "react";
import { Button, Input, notification, Select, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { path, sessionVar } from "../../../../utils/common/constant";
import { Detail, Editor } from "../../../../components";
import { apiCreateBlogs } from "../../../../services/blog";
import { uploadFile } from "../../../../services/file";
import { Box } from "@mui/material";
import { getSessionVar } from "../../../../utils/common/hashData";
import { Icon } from "@iconify/react/dist/iconify.js";

const CreateBlog = () => {
  const user = getSessionVar(sessionVar.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("../" + path.common.ADMIN);
    }
  }, []);

  const [formpayload, setformpayload] = useState({
    title: "",
    content: "",
    thumbnail: "",
    subtitle: "",
    creator: "IDG",
    category: "News",
  });
  const [file, setfile] = useState();

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false); // trạng thái submit
  const [isModalOpen, setIsModalOpen] = useState(false);

  const titleRef = useRef(null);
  const contentRef = useRef(null);
  const creatorRef = useRef(null);
  const thumbnailRef = useRef(null);

  const handleSetContent = (e) => {
    setformpayload({ ...formpayload, content: e });
  };

  const handleChange = (e) => {
    setformpayload({ ...formpayload, category: e });
  };

  // Chọn 1 file từ bộ nhớ
  const handleFilePicTitleChange = (event) => {
    const item = event.target.files?.[0]; // Lấy file đầu tiên trong danh sách
    const allowedExtensions = ["webp", "png", "jpg", "jpeg"]; // Định dạng hợp lệ
    const maxFileSize = 2 * 1024 * 1024; // Giới hạn kích thước file: 10MB

    if (item) {
      const fileExtension = item.name.split(".").pop().toLowerCase(); // Lấy đuôi file

      if (!allowedExtensions.includes(fileExtension)) {
        // Kiểm tra đuôi file
        notification.error({
          message: `File "${item.name}" is not a valid image format.`,
          duration: 2,
          placement: "topRight",
        });
      } else if (item.size > maxFileSize) {
        // Kiểm tra kích thước file
        notification.error({
          message: `File "${item.name}" exceeds the 2MB size limit.`,
          duration: 2,
          placement: "topRight",
        });
      } else {
        // Nếu file hợp lệ, cập nhật state
        setfile(item);
      }
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleUpload = async () => {
    if (file) {
      try {
        const formData = new FormData();
        formData.append("image", file); // Thêm file vào FormData

        const response = await uploadFile(formData);
        notification.success({
          message: "Upload image successfully  !!!",
          duration: 2,
          placement: "topRight",
        });
        setformpayload({ ...formpayload, thumbnail: response.path });
      } catch (error) {
        console.error("Upload Fail:", error);
      }
    } else {
      alert("Please select a file before uploading");
    }
  };

  const handleCreatBlog = async () => {
    let newErrors = {};
    if (!formpayload.title) newErrors.title = "Please enter a title";
    if (!formpayload.content) newErrors.content = "Please enter content";
    if (!formpayload.creator) newErrors.creator = "Please enter creator's name";
    if (!formpayload.thumbnail)
      newErrors.thumbnail = "Please upload image thumbnail";
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      await apiCreateBlogs(formpayload)
        .then((res) => {
          if (res.status === 200) {
            notification.success({
              message: "Create Blog successfully!",
              duration: 2,
              placement: "topRight",
            });
            navigate("../" + path.private.MANAGEBLOG);
          }
        })
        .catch((err) => {
          if (err.status === 401) {
            notification.info({
              message: "Your login session has expired!",
              duration: 3,
              placement: "topRight",
            });
            navigate("../" + path.common.LOGIN);
          }
        });
    }
  };

  return (
    <div className="">
      <div className="w-[90%] mx-auto h-auto bg-white shadow-xl rounded-lg p-1">
        <div className="flex p-2">
          <p className="text-2xl">Create Blog</p>
        </div>
        <div className="px-10 py-4 pv:max-ph:px-0 mx-auto w-[100%]">
          <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
            <p className="text-lg">
              Title
              <span className="text-red-500 text-[10px]">( * required)</span>
            </p>
            <input
              ref={titleRef}
              className="w-full h-auto border-[1px] p-2"
              placeholder="Title"
              value={formpayload.title}
              onChange={(e) =>
                setformpayload({ ...formpayload, title: e.target.value })
              }
            />
            {errors.title && (
              <p className="text-red-500 text-xs mt-1">{errors.title}</p>
            )}
          </div>

          <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
            <p className="text-lg">Subtitle</p>
            <input
              className="w-full h-auto border-[1px] p-2"
              placeholder="Subtitle"
              value={formpayload.subtitle}
              onChange={(e) =>
                setformpayload({ ...formpayload, subtitle: e.target.value })
              }
            />
          </div>
          <div className="w-full h-auto grid grid-cols-2 gap-4 ">
            <div className="flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg">Category</p>
              <Select
                defaultValue={formpayload.category}
                className="w-full h-auto "
                onChange={(e) => {
                  handleChange(e);
                }}
                options={[
                  {
                    value: "News",
                    label: "News",
                  },
                  {
                    value: "Event",
                    label: "Event",
                  },
                  {
                    value: "Market",
                    label: "Market",
                  },
                ]}
              />
            </div>
            <div className="flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg">
                Creator{" "}
                <span className="text-red-500 text-[10px]">( * required)</span>
              </p>
              {/* <input
                ref={creatorRef}
                className="w-full h-auto border-[1px]  p-2"
                placeholder="name"
                value={formpayload.creator}
                onChange={(e) =>
                  setformpayload({ ...formpayload, creator: e.target.value })
                }
              /> */}
              <select
                ref={creatorRef}
                className="w-full h-auto border-[1px] p-2"
                value={formpayload.creator}
                onChange={(e) =>
                  setformpayload({ ...formpayload, creator: e.target.value })
                }
              >
                <option value="" disabled>
                  Select creator
                </option>
                <option value="IDG">IDG</option>
                <option value="SOKO">SOKO</option>
              </select>
              {errors.creator && (
                <p className="text-red-500 text-xs mt-1">{errors.creator}</p>
              )}
            </div>
          </div>
          <div className="w-full h-auto flex pv:max-ph:flex-col  py-6">
            <div className="flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg flex pv:max-ph:flex-col">
                Thumbnail
                <span className="text-[10px]"> (jpg jpeg png webp (2MB))</span>
                <span className="text-red-500 text-[12px] ">
                  ( * Click upload image before saving )
                </span>
              </p>

              <input
                ref={thumbnailRef}
                type="file"
                accept="image/jpeg, image/png img/webp"
                onChange={(e) => {
                  handleFilePicTitleChange(e);
                }}
                className="pv:max-ph:w-[200px]"
              />
              {errors.thumbnail && (
                <p className="text-red-500 text-xs mt-1">{errors.thumbnail}</p>
              )}

              <Button
                type="primary"
                className=" w-[100px]"
                onClick={(e) => {
                  handleUpload();
                }}
              >
                <Icon
                  icon={"flowbite:upload-outline"}
                  className="w-6 h-6"
                ></Icon>
              </Button>
            </div>
            <img
              className={`w-[200px] h-[150px] object-cover `}
              alt="Image thumbnail"
              src={formpayload.thumbnail}
            ></img>
          </div>
          <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-20">
            <p className="text-lg">
              Content
              <span className="text-[10px] text-red-500">
                ( * Content to display on the details page)
              </span>
            </p>
            <div className="w-full" ref={contentRef}>
              <Box sx={{ margin: "0 auto" }}>
                <Editor setDescription={handleSetContent} />
              </Box>

              {errors.content && (
                <p className="text-red-500 text-xs mt-1">{errors.content}</p>
              )}

              <button
                className="px-6 py-2 rounded-lg bg-primary text-white my-4"
                onClick={() => {
                  setIsModalOpen(!isModalOpen);
                }}
              >
                {isModalOpen ? "Hidden" : "Preview"}
              </button>
            </div>
          </div>

          <div className="flex justify-center items-center gap-x-4">
            <Button
              className="w-auto h-auto py-2 px-4 "
              onClick={() => {
                navigate(-1);
              }}
            >
              <p className="">Back</p>
            </Button>

            <Button
              className="w-auto h-auto py-2 px-4 "
              type="primary"
              onClick={() => {
                handleCreatBlog();
              }}
            >
              Create Blog
            </Button>
          </div>
        </div>
      </div>
      <Modal
        title="Detail News"
        open={isModalOpen}
        onOk={handleOk}
        width={1140}
        onCancel={handleCancel}
      >
        <div>
          <div className="max-w-[1140px]  mx-auto  flex flex-col  items-center gap-2 justify-center py-4">
            <div className="">
              <p className="text-primary_light text-center  ">
                {formpayload?.category}
              </p>
            </div>
            <div className="text-justify max-w-[1140px] mx-auto ">
              <p className="text-primary text-4xl text-center">
                {formpayload?.title}
              </p>
            </div>
            <div className="w-[20px] bg-primary h-[2px]"></div>
            <div className="flex gap-4 justify-center items-center">
              <p className="text-primary text-sm">{formpayload?.creator}</p>
            </div>
          </div>

          {/* image part */}
          <div className="max-w-[1140px] mx-auto pt-[70px]  gap-4 md:max-lg:w-[90%]">
            <div className=" pb-[100px]">
              <img
                className="w-full h-[500px] object-cover md:rounded-xl "
                src={formpayload?.thumbnail}
                alt=""
              ></img>
            </div>
          </div>
          {/* <div className="max-w-[1140px] xl:mx-auto  text-primary_light text-[1.25rem] ">
              <Detail description={datadetail?.content} />
            </div> */}
          <div className="max-w-[1140px] xl:mx-auto text-base">
            <Detail description={formpayload?.content} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CreateBlog;
